import { hasOwn } from 'element-ui/src/utils/util';

export function isVNode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions');
};



// WEBPACK FOOTER //
// ./src/components/element/src/utils/vdom.js